var sm = exports

sm.Signature = require("./lib/signature")
sm.sm2 = require("./lib/sm2")
sm.sm3 = require("./lib/sm3")
sm.version = require("./package.json").version
